import { debug } from './debug';
import type { AnyObject } from 'zf-types';
import type { CustomDescriptor, KIND } from './types';

/**
 * 打印参数与返回值
 */
export function trace<Target, Params extends unknown[], Return>(kind: KIND = 'name') {
  return function(target: Target, context: ClassMethodDecoratorContext): CustomDescriptor<Return> {
    if (context.kind !== 'method') {
      return;
    }

    return async function(this: AnyObject, ...args: Params): Promise<Return> {
      const className = (this.constructor.name).toLowerCase();
      const methodName = context.name.toString().toLowerCase();
      const print = debug.features.extend(className).extend(methodName);

      if (kind === 'name') {
        print('called');
      }

      if (['params', 'all'].includes(kind)) {
        print('params', args);
      }

      const result = await ((target as AnyObject).apply(this, args) as Promise<Return>);
      if (['return', 'all'].includes(kind)) {
        print('return', result);
      }

      return result;
    };
  };
}
